import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { format, parseISO } from 'date-fns';
import { MarkdownRender } from '@/components/ui/markdown-render';

interface EventCardProps {
  event: {
    id: string;
    name: string;
    description: string;
    startDate: string;
  };
  orgId?: string; // optional, fallback to router param
  className?: string;
  bgMuted?: boolean; // for past events
}

export function EventCard({ event, orgId, className = '', bgMuted = false }: EventCardProps) {
  const navigate = useNavigate();
  const params = useParams();
  // Try to get orgId from props, otherwise from route params
  const resolvedOrgId = orgId || params.orgId;

  return (
    <div
      className={`border rounded-lg p-4 transition-colors cursor-pointer ${bgMuted ? 'bg-muted/30' : 'hover:bg-muted/50'} ${className}`.trim()}
      key={event.id}
      tabIndex={0}
      role="button"
      onClick={() => {
        if (resolvedOrgId) {
          navigate(`/app/org/${resolvedOrgId}/event/${event.id}`);
        }
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          if (resolvedOrgId) {
            navigate(`/app/org/${resolvedOrgId}/event/${event.id}`);
          }
        }
      }}
    >
      <div>
        <h3 className="font-medium text-lg">{event.name}</h3>
        <p className="text-sm text-muted-foreground">
          {format(parseISO(event.startDate), 'PPP p')}
        </p>
      </div>
      <MarkdownRender content={event.description} className="mt-2 whitespace-pre-wrap" />
    </div>
  );
}
